// extracted by mini-css-extract-plugin
export default {"nextStepButton":"ButtonNext_nextStepButton__RZ1Wg"};